import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "p-inputgroup" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "p-inputgroup-addon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "pi pi-filter" })
], -1)

import { SectorModelFragment } from "@/graphql/types";


export default /*#__PURE__*/_defineComponent({
  __name: 'SectorMultiselect',
  props: {
    options: {},
    modelValue: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any) {




return (_ctx: any,_cache: any) => {
  const _component_MultiSelect = _resolveComponent("MultiSelect")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_MultiSelect, {
      "model-value": _ctx.modelValue,
      options: _ctx.options,
      optionLabel: "name",
      "option-value": "id",
      "data-key": "id",
      placeholder: _ctx.$t('filterBy', { field: _ctx.$t('sector').toLowerCase() }),
      filter: true,
      display: "chip",
      "filter-fields": ['label'],
      filterPlaceholder: _ctx.$t('search'),
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:modelValue', $event)))
    }, null, 8, ["model-value", "options", "placeholder", "filterPlaceholder"])
  ]))
}
}

})